export default {
  title: '{{company}} ha aggiornato il tuo orario di ritiro',
  title_on_site: "{{company}} ha aggiornato l'orario di servizio del tuo ordine",
  new_time_label: 'Nuovo orario',
};
